import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = () => {
  const data = useStaticQuery(graphql`
    query SeoImage {
      file(name: { eq: "og-image-2" }) {
        publicURL
      }
    }
  `)

  const info = {
    title: `⚡️ $ALEX ⚡️`,
    description: `My goal is to build a disruptive, profitable company (or protocol) that could significantly improve the world.`,
    url: `https://alexmasmej.com`,
    imageURL: data.file.publicURL,
  }

  return (
    <Helmet>
      <title>{info.title}</title>
      <meta name="description" content={info.description} />

      {/***********  twitter cards ***********/}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={info.title} />
      <meta name="twitter:description" content={info.description} />
      <meta name="twitter:image" content={info.url + info.imageURL} />
      <meta name="twitter:creator" content="@AlexMasmej" />

      {/***********  open graph ***********/}
      <meta property="og:url" content={info.url} />
      <meta property="og:type" content={"website"} />
      <meta property="og:title" content={info.title} />
      <meta property="og:description" content={info.description} />
      <meta property="og:image" content={info.url + info.imageURL} />

      {/***********  schema ***********/}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "${info.title}",
        "url": "${info.url}",
      }
      `}</script>
    </Helmet>
  )
}

export default SEO
